var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Widget',{attrs:{"title":"Scratchpad","width":"600px","height":"450px"}},[_c('Notepad')],1)}
var staticRenderFns = []

export { render, staticRenderFns }